import { HttpParams, HttpParamsOptions } from "@angular/common/http";

export interface PaginateData<T>{
  data: Array<T>,
  total_items: number
}

export interface PaginateOptions {
  [index:string]:any;
  skip: number;
  take: number;
  order?: string;
  direction?: string;
  mainFilterField?:string;
  mainValueToFilter?:string | number;
  globalFilterValue?:string | number;
}
export const defaultPaginateSelects: PaginateOptions = {
  skip: 0,
  take: 100000,
  order: 'descripcion',
  direction: 'ASC',
  mainFilterField: '',
  mainValueToFilter: ''
}
export const DEFAULT_PAGINATE_OPTIONS_LIST: PaginateOptions = {
  skip: 0,
  take: 50,
  order: 'descripcion',
  direction: 'ASC',
  mainFilterField: '',
  mainValueToFilter: '',
  globalFilterValue: ''
}
